import { X } from "lucide-react";

function Modal({ title, children, onClose, wide = false }) {
  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
      <section className={`modal-card ${wide ? "modal-card--wide" : ""}`} role="dialog" aria-modal="true" aria-label={title}>
        <header><h2>{title}</h2><button className="icon-button" type="button" onClick={onClose} aria-label={`${title} 닫기`}><X size={19} /></button></header>
        {children}
      </section>
    </div>
  );
}

export default Modal;
